module.exports = __webpack_public_path__ + "static/media/Spanish-def-indef-articles.63e36e51.png";